import classNames from 'classnames'
import { JSX, ReactElement, ReactNode, useEffect, useRef } from 'react'

import { useIsMobile } from '@ds'
import { Inventory, Navbar } from '@shared'
import { webApp } from '@shared'
import { useNavbarActions } from '@store'

import styles from './MainLayout.module.scss'

interface MainLayoutProps {
  children:
  | ReactNode
  | ((scrollRef: React.RefObject<HTMLDivElement | null>) => ReactElement)
  showNavbar?: boolean
  showInventory?: boolean
  isNavbarFadeble?: boolean
}

export function MainLayout({
  children,
  showNavbar = true,
  showInventory = true,
  isNavbarFadeble = false,
}: MainLayoutProps): JSX.Element {
  const isMobile = useIsMobile()
  const scrollRef = useRef<HTMLDivElement>(null)
  const { setNavbarVisible } = useNavbarActions()
  const isDevelopment = import.meta.env.MODE === 'development'

  useEffect(() => {
    if (!showNavbar) {
      setNavbarVisible(false)
    }

    return () => {
      setNavbarVisible(true)
    }
  }, [showNavbar, setNavbarVisible])

  const content = (
    typeof children === 'function' && isNavbarFadeble
      ? children(scrollRef)
      : children
  ) as ReactNode

  return (
    <div
      className={classNames(styles.wrap, {
        [styles.showNavbar]: showNavbar && !isNavbarFadeble,
        [styles.isFullscreen]: (isMobile && webApp?.isFullscreen) || isDevelopment,
      })}
      id="main-layout"
    >
      {showInventory ? <Inventory /> : null}
      {content}
      {showNavbar ? (
        <Navbar
          isFadeble={isNavbarFadeble}
          scrollContainerRef={isNavbarFadeble ? scrollRef : undefined}
        />
      ) : null}
    </div>
  )
}
